import {
  displayDate,
  displayTime,
  VALID_DATE_FORMATS,
} from '@adsk/alloy-react-datetime';
import { useLocale } from '@adsk/alloy-react-locale';

export default function getTooltipDate(
  date: Date,
  T: ReturnType<typeof useLocale>['T'],
) {
  return T.translate('DATE_AT_TIME', {
    date: displayDate(date, { utc: false }),
    time: displayTime(date, {
      format: VALID_DATE_FORMATS.NUMERIC,
      utc: false,
    }),
  });
}
